module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("1"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "alt": " ",
      "src": "Images/ShortLine.jpg"
    }
  }), _c('br'), _vm._v("\n  How the Me-Centered World Was Born")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/6450_CH.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "initial-cap"
  }, [_vm._v("A")]), _vm._v("s children we never questioned our identity or wondered about our place in life. Nor did we think of our “selves” as distinct from our relationships, activities and feelings. We just lived in the context we were born into and followed the natural course of our lives. But as we grew older we were encouraged to discover our own unique blend of preferences, talents and joys, and to create an identity for ourselves through our choices and actions. In contrast to previous ages, modern culture denies that one can become an authentic person or experience fulfillment in life by conforming to natural or socially given relationships and roles. Instead we are taught that our self-worth and happiness depend on reconstructing ourselves according to our desires. And the project of redesigning ourselves necessitates that we continually break free from the web of social"), _c('a', {
    attrs: {
      "id": "eNote0003"
    }
  }), _vm._v(" relationships and expectations that would otherwise impose an alien identity on us."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[1]")])]), _vm._v(" I am calling this understanding of the self “me-centered,” not because it is especially selfish or narcissistic but because it attempts to create its identity by sheer will power and rejects identity-conferring relationships unless they are artifacts of its own free will. It should not surprise us, then, to find that the modern person feels a weight of oppression and a flood of resentment when confronted with the demands of traditional morality and religion. In the face of these demands the me-centered self feels its dignity slighted, its freedom threatened and its happiness diminished.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In this chapter I draw heavily on the work of moral philosophers Charles Taylor and Alasdair MacIntyre to answer the following question: How, when and by whom did it come about that nature, family, community, moral law and religion were changed in the Western mind from"), _c('a', {
    attrs: {
      "id": "eNote0004"
    }
  }), _vm._v(" identity-giving, happiness-producing networks of meaning into their opposites—self-alienating, misery-inducing webs of oppression?"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[2]")])]), _vm._v(" How was the me-centered world formed?")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "heading_id_3"
    }
  }, [_vm._v("Searching for Identity in a Secular Age")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In his "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Sources of the Self")]), _vm._v(" (1989) and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("The Secular Age")]), _vm._v(" (2007), Charles Taylor argues that to possess an identity is to be located in a moral “space” whose coordinates are determined by certain goods and moral sources. The question Who am I? is answered by"), _c('a', {
    attrs: {
      "id": "eNote0005"
    }
  }), _vm._v(" “knowing where I stand” in relation to these goods and moral sources."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[3]")])]), _vm._v(" As Taylor explains, “To know who you are is to be oriented in moral space, a space in which questions arise about what is good or bad, what is worth doing and what not, what"), _c('a', {
    attrs: {
      "id": "eNote0006"
    }
  }), _vm._v(" has meaning and importance for you and what is trivial and secondary.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[4]")])]), _vm._v(" Oriented within this space I can know what I ought to do, what is valuable, worthwhile and admirable. Modern moral space possesses three axes that provide coordinates (x, y, z) within which to locate ourselves."), _c('a', {
    attrs: {
      "id": "eNote0007"
    }
  }), _vm._v(" Each axis represents a set of “strongly valued goods.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[5]")])]), _vm._v(" That is, these “ends or goods stand independent of our own desires, inclinations, or choices,"), _c('a', {
    attrs: {
      "id": "eNote0008"
    }
  }), _vm._v(" that they represent standards by which these desires and choices are judged.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[6]")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/6450_FIG1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("They are (x) a sense of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("respect")]), _vm._v(" for and obligation to others, (y) a sense of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fullness")]), _vm._v(" in life or what makes life worth living, and (z) a sense of our own "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dignity")]), _vm._v(" or what makes us worthy of respect (see fig. 1).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The shape of modern identity can be determined by coming to understand the way contemporary culture appropriates these fundamental values in contrast to the way premodern culture understood them. To give us historical perspective, Taylor traces in three trajectories how these strong values acquired their modern shape. He shows how (1) the growth of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("inwardness")]), _vm._v(" transferred moral principles from outside the human person to inside, (2) the Christian "), _c('em', {
    staticClass: "i"
  }, [_vm._v("affirmation of ordinary life")]), _vm._v(" gradually led Western culture to focus on human flourishing in this world as the exclusive human goal, and (3) the development of an "), _c('em', {
    staticClass: "i"
  }, [_vm._v("expressive view of inner nature")]), _vm._v(" produced a completely subjective view of the good. Taylor’s three historical motifs provide the following outline. We will see how each of these trajectories adds to our understanding of the modern self’s take on the strong values of respect, fullness and dignity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("The development of inwardness")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v(".")]), _vm._v(" In contrast to modern inwardness, ancient tribal and warrior cultures people found their identity in a moral space where respect, fullness and dignity were grounded in external things such as family status or war and the glory it achieves. Taking a first step toward inwardness, Plato (c. 428/27-347/48 b.c.) criticized the warrior morality, arguing that"), _c('a', {
    attrs: {
      "id": "eNote0009"
    }
  }), _vm._v(" desire for glory and other unruly emotions must be subordinated to reason."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[7]")])]), _vm._v(" Reason’s power of self-control centers the self and bestows the capacity for cool, deliberate action. But Plato does not locate all goods and moral sources within the self. For Plato, to reason is to see the natural order of the world and perceive the transcendent good to which it is directed. And one becomes a good human being by imitating the good thus revealed.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The Christian thinker Augustine of Hippo (a.d. 354-430) takes Plato’s thinking further toward inwardness. When we turn our thoughts inward to consider our minds, we discover a vast mystery. The mind contains an endless universe of ideas and memories; it can even think about itself. Yet the mind cannot comprehend itself, explain its own powers or create the ideas it contains. Hence, Augustine concludes that our minds must"), _c('a', {
    attrs: {
      "id": "eNote0010"
    }
  }), _vm._v(" be created and illuminated by an even greater mystery, a divine mind."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[8]")])]), _vm._v(" So Augustine finds humanity’s greatest good revealed not in the natural order but in the divine truth seen by introspection. In contrast to Plato, Augustine denies that one can see the good just by turning to the natural order. We must also possess purity of heart, which only the grace of God can bestow. Here Augustine introduces a new function of the will, derived from Christianity, into Western thought. Right reason cannot function properly in a person who desires evil. We must "), _c('em', {
    staticClass: "i"
  }, [_vm._v("will")]), _vm._v(" the transcendent good before we can see it clearly. Hence, the will must be liberated from evil desires before the mind can endure the truth. Even though Augustine’s inward turn was revolutionary, he did not yet identify the human soul with the good and the true. The soul is merely the place where one can perceive the truth that transcends even the soul. Thinkers after Augustine followed his example in looking for the true good within the soul.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("René Descartes and disengaged reason")]), _vm._v(". The next step toward placing moral values"), _c('a', {
    attrs: {
      "id": "eNote0011"
    }
  }), _vm._v(" wholly inside the self was facilitated by a revolution in natural science."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[9]")])]), _vm._v(" Galileo (1564-1642) is famous for using a telescope to spot Jupiter’s moons; however, more enduring was his revolution of changing the metaphor for interpreting the physical world. Before Galileo, philosophers thought of the physical world as a combination of matter and form or idea. The world was a sort of living body, composed of matter and soul. In contrast, Galileo saw the world as a machine, as dead matter arranged by God in a certain order. The body of the world no longer possesses a soul. The French philosopher René Descartes (1596-1650) accepted Galileo’s view that the world is a material machine bereft of soul. But he did not want to accept atheism or reduce everything to matter; hence, to preserve the existence of nonmaterial forms and purposes Descartes relocated them within the mind. The human mind does not get its ideas from the external cosmic order. Instead, it imposes its internal order on the external world like God does. Notice the difference between Descartes and Plato. In Plato, the human mind humbly allows itself to be shaped by the natural order. For Descartes, mind—whether divine or"), _c('a', {
    attrs: {
      "id": "eNote0012"
    }
  }), _vm._v(" human—asserts its superiority over the external world by imposing itself on it."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[10]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Shifting from a passive to an active understanding of the mind’s relationship to the world leads inexorably to a shift in human self-understanding and moral theory. For Descartes, our bodies are machines just like the rest of the world, so we can direct them and their emotions with reason in the same way we control the external world. The emergence of this dominating attitude toward the world and human nature indicates a profound change in Descartes’s understanding of freedom. For Plato and the Platonic tradition, freedom can be attained only by bringing one’s life into harmony with the ideal order that gives form and being to the world. For Descartes, freedom is the natural power to rule oneself as one chooses:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Now freewill is in itself the noblest thing we can have because it makes us in a certain manner equal to God and exempts us from being his subjects; and so its rightful use is the greatest of all goods we possess, and further there is nothing that is more our own or that matters more to us. From all"), _c('a', {
    attrs: {
      "id": "eNote0013"
    }
  }), _vm._v(" this it follows that nothing but freewill can produce our greatest contentment."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[11]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In this framework, moral sources have been completely internalized within the mind. Our understanding of what is good and our power to attain it now must come from within,"), _c('a', {
    attrs: {
      "id": "eNote0014"
    }
  }), _vm._v(" from “the agent’s sense of his own dignity as a rational being.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[12]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("John Locke and the punctual self")]), _vm._v(". John Locke (1632-1704) differed profoundly from Descartes in many ways, but he continued the path tread by Descartes toward disengaging the self from the matrix of nature. Locke was radically antiteleological, that is, he believed that there are no inherent ends "), _c('em', {
    staticClass: "i"
  }, [_vm._v("(teloi)")]), _vm._v(" toward which the world or human nature strives. Human nature does"), _c('a', {
    attrs: {
      "id": "eNote0015"
    }
  }), _vm._v(" not possess “an inherent bent to the truth or to the good.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[13]")])]), _vm._v(" This rejection of teleology works a revolution in ethics. We cannot think of human nature as made for truth or love or any virtue. According to Locke, human nature inherently seeks only pleasure and avoids only pain. There is no inherent connection between essential human nature and moral good or evil that would guarantee that good always produces happiness and evil unhappiness. This connection"), _c('a', {
    attrs: {
      "id": "eNote0016"
    }
  }), _vm._v(" must be established arbitrarily and extrinsically, by God or habit or tradition."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[14]")])]), _vm._v(" If we choose, we can disengage from this habitual connection and remake ourselves in any way we choose. Aristotle (384-322 b.c.) noted that a habit can be formed with or against the grain of nature. For Locke, however, there is no grain of nature, and a habit is a mere association of atoms of experience. As Taylor explains, “Habits now link elements between which there are no more relations of natural fit. The proper connections are determined"), _c('a', {
    attrs: {
      "id": "eNote0017"
    }
  }), _vm._v(" purely instrumentally, by what will bring the best results, pleasure, or happiness.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[15]")])]), _vm._v(" For Locke, the self has no identifying attributes or relations or unchangeable structures."), _c('a', {
    attrs: {
      "id": "eNote0018"
    }
  }), _vm._v(" It is just an extensionless point, which Taylor calls the “punctual self.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[16]")])]), _vm._v(" On this reading, the modern self sits sovereign above the world, impressing its arbitrary will on a neutral external reality and reconstructing itself according to its whims.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The moral space of inwardness")]), _vm._v(". Where does the history of internalization of moral sources locate modern identity on the three axes of moral space (see. fig. 1)? First, on the x axis of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("respect")]), _vm._v(", if internalization and rational self-control mark the being of others we will see other people as individual autonomous agents and feel a special respect for their right to control their own lives. On the y axis of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fullness")]), _vm._v(", we will assume that fullness in life consists in ordering one’s passions according to reason and imposing one’s will on the external world. Perhaps living in this way brings about a sense of satisfaction at being in control of oneself and in exerting of power over nature. And on the z axis of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dignity")]), _vm._v(", one will find one’s dignity in the inner integrity of one’s being and in the power of self-control over passion and error. For the modern self, then, the most powerful reasons to respect others, the surest path to fullness and the clearest basis on which to assert our own dignity are internal to ourselves and others.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("Affirmation of ordinary life")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v(".")]), _vm._v(" In traditional societies certain ways of living possess higher dignity than others do. In ancient warrior cultures a life of military glory and honor was to be sought above all others. But Plato criticized ambition for glory and advocated devoting oneself to wisdom. In his "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Politics")]), _vm._v(" Aristotle admits the necessity of living on the level"), _c('a', {
    attrs: {
      "id": "eNote0019"
    }
  }), _vm._v(" of ordinary life, which Taylor calls the life of “production and reproduction.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[17]")])]), _vm._v(" But ordinary life is merely a foundation from which one can aspire to the truly good life. For Aristotle, one should seek excellence in contemplating the natural order and in deliberating with others about the common good of the political community one can achieve the good life in. The Stoic philosophers pronounced an even more negative judgment on ordinary life, urging that wisdom dictates that one detach oneself from the fluctuating passions of the body so one can devote oneself to the unchanging order of reason.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Christianity affirms the goodness of creation and ordinary life, but it also holds dear the ideal of a life dedicated totally to God. The monastic movements of the early centuries, though not denying that ordinary life was good and could be acceptable to God, sought a higher spiritual plane by sacrificing marriage, family, society and commerce. Accordingly, medieval Christianity developed a hierarchical theory of the Christian life. Some are called out of ordinary life into monastic orders and the priesthood. These Christians devote themselves to prayer and study, and they refrain from marriage. They aim to achieve a higher level of holiness and merit before God, which can benefit the whole community. This system can lead to the idea that the laity need not concern itself with holiness and piety because these virtues are the province of monastic orders and clergy. Aware of this danger, medieval church authorities and reformers of various types attempted periodically to close the gap between the two levels. The Fourth Lateran Council (1215), one of the earliest of these efforts, required all Roman"), _c('a', {
    attrs: {
      "id": "eNote0020"
    }
  }), _vm._v(" Catholics to participate in confession and Communion at least once a year."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[18]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The sixteenth-century Protestant Reformation inspired a revolutionary movement aimed at collapsing the spiritual hierarchy and affirming ordinary life. The Protestant Reformers taught that salvation came by faith alone rather than by self-negating works, and that believers did not need the mediation of a priest to relate to God. The Protestant monarchs closed the monasteries within their lands and urged the clergy to marry and have children. Indeed, the Reformers came to see monastic life as a place of spiritual pride and elitism, and as a slight to God’s good creation. On the other hand, they affirmed the ordinary life of labor and"), _c('a', {
    attrs: {
      "id": "eNote0021"
    }
  }), _vm._v(" family as the locus of the highest achievement in the Christian life."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[19]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In seventeenth-century Puritan theology of vocation each person is called by God into a life conducive to the good of the whole community. It matters not in what calling one is stationed but in what spirit one carries out one’s vocation. The Puritan theologian"), _c('a', {
    attrs: {
      "id": "eNote0022"
    }
  }), _vm._v(" William Perkins’s words bring this view to expression in good Elizabethan English:"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[20]")])])]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Now the works of every calling, when they are performed in an holy manner, are done in faith and obedience, and serve notably for God’s glory be the calling never so base. . . . The meaneness of the calling, doth not abase the goodnesse of the worke: for God looketh not at the excellence of the Work, but at the heart of the worker. And the action of a sheepheard in keeping sheep, performed as I have said, in his kind, is as good a worke before God, as is the action of a Judge, in giving sentence or a Magistrate in ruling, or a Minister in preaching.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("It is not difficult to see how the grandchildren of these Puritans might retain their enthusiasm for ordinary life well after leaving their piety behind. One might come to believe that giving oneself to family and work is the whole of one’s duty to God. Or one might forget God altogether and immerse oneself in the search for worldly success. John Locke and his heirs actually took this step.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("John Locke and his friends")]), _vm._v(". John Locke"), _c('a', {
    attrs: {
      "id": "eNote0023"
    }
  }), _vm._v(" combined Protestant affirmation of ordinary life with the ideal of rational self-control."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[21]")])]), _vm._v(" For Locke the law of nature is revealed in the innate human desire for self-preservation. When we follow this law as interpreted by reason we can be sure that we are also doing God’s will:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("For the desire, strong desire of Preserving his Life and Being having been implanted in him, as a Principle of Action by God himself, Reason, which was the voice of God in him, could not but teach him and assure him, that pursuing that natural inclination he"), _c('a', {
    attrs: {
      "id": "eNote0024"
    }
  }), _vm._v(" had to preserve his Being, he followed the Will of his Maker."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[22]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Still, human nature does not possess an inherent bent toward the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("good")]), _vm._v(". Rather, God motivates us to do right by promising rewards and"), _c('a', {
    attrs: {
      "id": "eNote0025"
    }
  }), _vm._v(" threatening punishments, thereby using our self-love as a foundation for civil life."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[23]")])]), _vm._v(" We are not made for the dizzy heights of “self-abnegating"), _c('a', {
    attrs: {
      "id": "eNote0026"
    }
  }), _vm._v(" altruism” but for the ordinary life of seeking pleasure and avoiding pain."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[24]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The next move toward a completely secular view of human life was accomplished by deism, the intellectual movement that dominated eighteenth-century philosophy. Deism does not reject belief in God and providence; yet it sees God’s work limited to promoting human welfare on the purely human plane. Matthew Tindal (1655-1733) argues that God wishes only"), _c('a', {
    attrs: {
      "id": "eNote0027"
    }
  }), _vm._v(" to promote the “common good, and mutual Happiness of his rational creatures.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[25]")])]), _vm._v(" We can follow God’s plan for creation by living according to the natural order, which is designed so"), _c('a', {
    attrs: {
      "id": "eNote0028"
    }
  }), _vm._v(" that seeking one’s own happiness harmonizes with seeking the good of others."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[26]")])]), _vm._v(" “Which means,” as Taylor puts it,"), _c('a', {
    attrs: {
      "id": "eNote0029"
    }
  }), _vm._v(" “fundamentally that we owe [God] essentially the achievement of our own good.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[27]")])]), _vm._v(" Living in harmony with nature does not mean adjusting one’s life to the natural order, as it would for"), _c('a', {
    attrs: {
      "id": "eNote0030"
    }
  }), _vm._v(" Plato; rather, it means balancing the two principles of self-love and reason."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[28]")])]), _vm._v(" Tindal says bluntly:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Whoever so regulates his natural appetites as will conduce most to the exercise of his reason, the health of his body and the pleasures of his senses taken and considered together (since herein his happiness consists) may be certain he can never offend his Maker; who, as he governs all things according to their natures,"), _c('a', {
    attrs: {
      "id": "eNote0031"
    }
  }), _vm._v(" can’t but expect his rational creatures should act according to their natures."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[29]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Tindal’s conclusion that creatures should “act according to their natures” involves something more nuanced than Locke’s view of living according to nature—simply seeking pleasure and avoiding pain; Tindal means we need to become aware"), _c('a', {
    attrs: {
      "id": "eNote0032"
    }
  }), _vm._v(" of our inner “inclinations, desires, sentiments” and view them as guiding norms."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[30]")])]), _vm._v(" Taylor explains the significance of this difference:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Sentiment is now important, because it is in a certain way the touchstone of the morally good. . . . [U]ndistorted, normal feeling is my way of access into the design of things, which is the real constitutive good, determining good and bad. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("The new place of sentiment completes the revolution which has yielded a modern view of nature as normative, so utterly different from the ancient view. . . . [I]t is ready to become the voice within, which Rousseau will make it, and"), _c('a', {
    attrs: {
      "id": "eNote0033"
    }
  }), _vm._v(" to be transposed by the Romantics into a richer and deeper inwardness."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[31]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The history of the affirmation of ordinary life, which began as affirmation of God’s creation and the dignity of whatever vocation God gives us, thus ends as the sanctification of our inner nature as revealed in our “inclinations, desires and sentiments.” Once this sanctification occurred it would not take long for some thinkers to begin to view any effort to discipline this inner inclination in view of moral law or divine commands as oppression and any form of its expression as legitimate.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The moral space of the affirmation of ordinary life")]), _vm._v(". Where does this history place us in the moral space determined by the three axes: respect, fullness and dignity? "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Respect")]), _vm._v(" for others must be grounded in the inherent properties of the individual rather than in any external relation or order; specifically, it is grounded in the inner desires of the individual, which presumably reveal the design of the Creator. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Fullness")]), _vm._v(" can be found only in living according to nature as it is revealed in one’s affections. A full life can be enjoyed not only by moral elites or heroes who attain it with great self-sacrifice or bold action; it is available to the vast majority of people in the ordinary course of life: marriage, children, work and play. A sense of one’s "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dignity")]), _vm._v(" can be experienced in feeling the moral law come to light in one’s feelings and inclinations. The imperatives of morality come from within and cannot be imposed by an external authority. Though at this stage the moral law is still understood to derive from God’s creation, all attempts to impose law from without now seem incommensurate with affirmation of human dignity. The stage is now set for declaring God completely unnecessary for living a flourishing human life.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("The inner voice of nature")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v(".")]), _vm._v(" Deism prepared the soil for modern atheism. It had already internalized all moral sources, declared that human welfare in this life should be our major concern and relegated God to a mere presupposition of the order of nature. The final step of declaring God a needless hypothesis was taken by the “radical Enlighteners” Denis Diderot (1713-1784), Baron"), _c('a', {
    attrs: {
      "id": "eNote0034"
    }
  }), _vm._v(" d’Holbach (1723-1789), Jeremy Bentham (1748-1832) and Julien Offray de La Mettrie (1709-1751)."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[32]")])]), _vm._v(" These thinkers do not consider nature an embodiment of divine law but a neutral field for the play of reason in maximizing pleasure and minimizing pain. They developed a utilitarian ethical theory in which reason calculates which behaviors will lead to the best consequences in keeping with the goal of maximizing pleasure. As self-contradictory as it may seem, however, most late-eighteenth-century atheist thinkers passionately defended the same order of"), _c('a', {
    attrs: {
      "id": "eNote0035"
    }
  }), _vm._v(" goods deism had defended: “self-responsible reason, affirmation of ordinary life and benevolence.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[33]")])]), _vm._v(" They differed from deism in their contention that atheism is superior to belief in God in defending these goods. The radical enlightenment looked to nature alone, uncreated and unguided, for human well-being and happiness. Baron d’Holbach speaks in the voice of nature to humans mired in religion:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("“O thou!” cries this nature to man, “who, following the impulse I have given you, during your whole existence, incessantly tend towards happiness, do not strive to resist my sovereign law. Labour to your own felicity; partake without fear of the banquet which is spread before you, and be happy; you will find the means legibly written on your own heart. . . . Dare, then, to affranchise thyself from the trammels of religion, my self-conceited, pragmatic rival, who mistakes my rights; renounce those Gods, who are usurpers of my privileges, and return under the dominion of my laws. It is in my empire alone that true liberty reigns. Tyranny is unknown to its soil. . . ."), _c('a', {
    attrs: {
      "id": "eNote0036"
    }
  }), _vm._v(" Return, then, my child, to thy fostering mother’s arms!"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[34]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("But not everyone in the late eighteenth century found atheism and utilitarianism appealing. Jean-Jacques Rousseau (1712-1778) began as an admirer but later became a leading critic of the Enlightenment. According to Rousseau, the Enlightenment was too optimistic about the innocence of human nature. As we experience it, human nature possesses a dark side and needs transformation. However, Rousseau did not return to orthodox Christianity’s view of the fall, original sin and divine grace. Rather, he blamed civilization for poisoning the original impulses of nature with its artificial overlay. We do not need more science, more knowledge or more scholars. We need to listen to the voice of nature within, depend on ourselves"), _c('a', {
    attrs: {
      "id": "eNote0037"
    }
  }), _vm._v(" rather than on others and find power within ourselves for our actions."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[35]")])]), _vm._v(" The first line in his novel "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Emile, or On Education")]), _vm._v(", Rousseau declares, “Everything is good in leaving the hands"), _c('a', {
    attrs: {
      "id": "eNote0038"
    }
  }), _vm._v(" of the Creator of things; everything degenerates in the hands of man.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0038",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[36]")])]), _vm._v(" Later he says, “Let us lay it down as an incontrovertible rule that the first impulses of nature"), _c('a', {
    attrs: {
      "id": "eNote0039"
    }
  }), _vm._v(" are always right; there is no original sin in the human heart.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[37]")])]), _vm._v(" He continues almost to the point of deifying the inner voice:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Conscience! Conscience! Divine instinct, immortal voice from heaven; sure guide for a creature ignorant and finite indeed, yet intelligent and free; infallible judge of good and evil, making man like to God! In thee consists the excellence of man’s nature and the morality of his actions; apart from thee, I find nothing in myself to raise me above the beasts—nothing but the sad privilege of wandering from one error to another, by the"), _c('a', {
    attrs: {
      "id": "eNote0040"
    }
  }), _vm._v(" help of an unbridled understanding and a reason which knows no principle."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[38]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Certain thinkers in the late eighteenth and early nineteenth century continued the course pioneered by Rousseau, pursuing the idea that"), _c('a', {
    attrs: {
      "id": "eNote0041"
    }
  }), _vm._v(" the inner voice of nature seeks expression in our words and feelings."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[39]")])]), _vm._v(" In some writers the voice of nature is considered part of a great current of feeling flowing through all things and given voice in individuals. That great current can be interpreted as a divine power or as the prompting of"), _c('a', {
    attrs: {
      "id": "eNote0042"
    }
  }), _vm._v(" my unique individual nature, which determines my way to freedom and joy."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[40]")])]), _vm._v(" Hence, articulating my unique nature becomes crucially important to authentic living, to a life that arises out of my genuine individuality. Philosopher of language Johann Gottfried Herder (1744-1803), sounding almost like a contemporary celebrity offering advice as unsolicited as it is half-baked, gave classic expression to this now familiar philosophy: “Each human being has his own measure, as it were"), _c('a', {
    attrs: {
      "id": "eNote0043"
    }
  }), _vm._v(" an accord peculiar to him of all his feelings to each other.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[41]")])]), _vm._v(" Experiencing my true self fully requires that I put my inner nature into an external medium: words, visual art, dance, song or other acts. In expressing myself I do not simply make an outer copy"), _c('a', {
    attrs: {
      "id": "eNote0044"
    }
  }), _vm._v(" of something already complete inside; rather, I complete and further define myself."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[42]")])]), _vm._v(" Expressive individualism provides no guarantees that"), _c('a', {
    attrs: {
      "id": "eNote0045"
    }
  }), _vm._v(" our inner voice will impel us toward virtuous behaviors or conventional goods."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[43]")])]), _vm._v(" Self-expression and the feeling of joy or sense of freedom it engenders are not valued for the sake of higher goods or right actions; they are ends in themselves."), _c('a', {
    attrs: {
      "id": "eNote0046"
    }
  }), _vm._v(" Such expressive individualism “has become one of the cornerstones of modern culture.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[44]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("The moral space of the expressive view of nature")]), _vm._v(". Where does this history place us in the moral space determined by the three axes: respect, fullness and dignity? "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Respect")]), _vm._v(" for others is grounded in the uniqueness of their individual and private inner natures, which must be given space to find expression. To judge them as unworthy examples of humanity or dictate how they should express their uniqueness would violate their essential personhood. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Fullness")]), _vm._v(" can be found only in the freedom and joy engendered by bringing to external expression one’s inner nature. It cannot be found by conforming to an external code or submitting to an alien authority or seeking a transcendent good. A sense of one’s own "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dignity")]), _vm._v(" is rooted in one’s uniqueness and in the power of self-creation and self-definition by means of self-expression. The modern self asserts, “I am irreplaceable, and none can tell me how to realize my own uniqueness or judge my choice of ways of self-expression. I have every right to celebrate my own utterly unique being in ways that I experience as fulfilling.”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("Realistic expectations")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v(".")]), _vm._v(" Taylor’s analysis confirms what I have experienced in interactions with my contemporaries: The modern self is me-centered. Most people are not self-centered in the crass sense of being selfish or narcissistic; nevertheless they locate all values and sources of fulfillment within the self, in its feelings, preferences, thoughts, opinions and wishes. Even when they cannot articulate it this way, they ground the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("respect")]), _vm._v(" they feel for others in such inward qualities as autonomy, inner desires and a unique inner depth that requires expression. It would seem odd to ground respect for others in something extrinsic, such as divine creation or divine love or a divine command. Withholding respect from others because of their choices or desires or ways of self-expression strikes our contemporaries as irrational and hateful. We can expect that most people we meet are seeking "), _c('em', {
    staticClass: "i"
  }, [_vm._v("fullness")]), _vm._v(" by realizing the potential within by way of rational self-mastery or through self-expression of an inner depth. They reject the notion that fullness is reserved for an elite group, that it is received by grace or that it must wait until an afterlife. We need not be surprised that most people will understand their "), _c('em', {
    staticClass: "i"
  }, [_vm._v("dignity")]), _vm._v(" as rooted in qualities intrinsic to their persons, in their autonomy or feelings of worth or unique individuality. They cannot conceive of their dignity as rooted in something extrinsic, a relationship to God, for example.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "heading_id_4"
    }
  }, [_vm._v("The Self in a Culture Set Adrift")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In his trilogy, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("After Virtue")]), _vm._v(" (1981), "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Whose Justice? Which Rationality?")]), _vm._v(" (1988), and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Three Rival Versions of Moral Enquiry")]), _vm._v(" (1990), moral philosopher Alasdair MacIntyre sets out his understanding of the contemporary moral situation, gives a historical account of how this state of affairs developed and defends an alternative moral understanding. As MacIntyre sees it, from the halls of the university to the street corner contemporary society has lost its ability to carry on rational discussion of moral issues. In the background of all moral discussions today lurks the assumption that moral judgments do not make judgments of fact or truth. Instead they express feelings of approval or disapproval, of"), _c('a', {
    attrs: {
      "id": "eNote0047"
    }
  }), _vm._v(" pleasure or distress at some situation, a theory MacIntyre identifies as emotivism."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[45]")])]), _vm._v(" Even arguments that seem to appeal to facts or truths quickly reveal themselves as efforts to express feelings and create those feelings in others. “We might conclude,” says MacIntyre, “that there is nothing to such contemporary disagreements but a clash of antagonistic wills,"), _c('a', {
    attrs: {
      "id": "eNote0048"
    }
  }), _vm._v(" each will determined by some set of arbitrary choices of its own.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[46]")])]), _vm._v(" It is as if some great catastrophe had taken place in which all memory of how to reason morally was erased, leaving only scattered fragments of moral ideas lying about a ruin. What passes for moral arguments are really strings of incoherent assertions uprooted from their original settings. But why, then, do people still assert their preferences in the form of rational arguments? Perhaps a residual suspicion remains that moral claims need justifying with reference to fact or truth after all, and this suspicion makes the rhetorical ploy necessary and effective.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("The emotivist self")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v(".")]), _vm._v(" In premodern societies, a person was identified by membership in a tribe, village or family. One is a daughter, a cousin, a grandson, a farmer or a cobbler. These are not accidental characteristics or roles I can disengage my real self from. They are my substance, my very self. An individual self is not merely an extensionless point but a set of relationships extended"), _c('a', {
    attrs: {
      "id": "eNote0049"
    }
  }), _vm._v(" in space and in movement toward an end fitted to its nature."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[47]")])]), _vm._v(" In contrast, the self presupposed by emotivism possesses no “necessary social identity” or moral nature or irrevocable commitments. It “can assume any role or take any point of view, because it is in and for itself nothing. . . ."), _c('a', {
    attrs: {
      "id": "eNote0050"
    }
  }), _vm._v(" [It is] a set of perpetually open possibilities.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[48]")])]), _vm._v(" It is pure will open to any possibility. MacIntyre explores three activities characteristic of this modern self: the arbitrary claim to possess rights, the inclination to protest and the strategy of unmasking. This self asserts certain rights"), _c('a', {
    attrs: {
      "id": "eNote0051"
    }
  }), _vm._v(" against other people, but can offer no rational justification for these claims."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[49]")])]), _vm._v(" Hence, when the self feels that its rights are being violated, the façade of rational argument quickly falls away leaving nothing but protest and indignation."), _c('a', {
    attrs: {
      "id": "eNote0052"
    }
  }), _vm._v(" Protest, according to MacIntyre, is a “distinctive feature of the modern age.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[50]")])]), _vm._v(" Unmasking too is distinctively modern. When you know that rational arguments are but rhetorical stratagems masking self-interest and arbitrary will, unmasking becomes the appropriate counter-strategy. But how was the emotivist self formed?")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "bi"
  }, [_vm._v("The end of ends and the Enlightenment quest")]), _c('strong', {
    staticClass: "b"
  }, [_vm._v(".")]), _vm._v(" According to MacIntyre, the fourteenth through seventeenth centuries saw the gradual breakdown of the ancient moral tradition, the central core of which was Aristotle’s "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Nicomachean Ethics.")]), _c('a', {
    attrs: {
      "id": "eNote0053"
    }
  }), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[51]")])]), _vm._v(" This tradition understood human"), _c('a', {
    attrs: {
      "id": "eNote0054"
    }
  }), _vm._v(" beings as possessing an “essential nature and an essential purpose or function.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[52]")])]), _vm._v(" The human essence and end are given prior to choice and are unchangeable. Within this framework moral judgments make sense as judgments of fact. To call x—a person, an action or anything—“good” is to say that “it is the kind of thing which someone would choose who"), _c('a', {
    attrs: {
      "id": "eNote0055"
    }
  }), _vm._v(" wanted an x for the purpose for which x’s are characteristically wanted.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[53]")])]), _vm._v(" A watch is good insofar as it keeps time accurately. A right or a just action is what “a good man would do"), _c('a', {
    attrs: {
      "id": "eNote0056"
    }
  }), _vm._v(" in such a situation; hence this type of statement too is factual.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[54]")])]), _vm._v(" Virtues are characteristics that enable an individual to attain the end implicit within the human essence. The human end cannot be attained apart from those virtues because becoming a good human being is an essential aspect of that achievement. But when a culture denies that human beings possess essential natures and ends, the notion that moral judgments are statements of fact also drops away; it then becomes necessary to find other justifications for desired actions.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("MacIntyre tells the story of the Enlightenment’s futile search for a replacement for the teleological understanding of human nature. He begins at the end, at the point where it becomes clear that the quest has failed, and works backward. Søren Kierkegaard (1813-1855) wrote "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Either/Or")]), _vm._v(" as a epitaph for Immanuel Kant’s project of grounding morality in reason. Kierkegaard presents the reader with two completely incommensurable ways of life, the esthetic (A) and the ethical (B). The esthete (A) is immersed in the pursuit of pleasure without regard to the distinction between good and evil. It is not as if the esthete chooses evil over good; rather, for the esthete the ethical framework that makes the choice necessary simply does not exist. All that matters is the feeling of pleasure. The ethical (B) person lives life structured by the distinction between good and evil, typified by the traditional morality of marriage, truth telling and promise keeping. In "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Either/Or")]), _vm._v(", “the choice between the ethical and the aesthetic is not the choice between good and evil, it is the"), _c('a', {
    attrs: {
      "id": "eNote0057"
    }
  }), _vm._v(" choice whether or not to choose in terms of good and evil.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[55]")])]), _vm._v(" According to MacIntyre, Kierkegaard assumes the failure of all previous attempts to justify living a moral life and presents it"), _c('a', {
    attrs: {
      "id": "eNote0058"
    }
  }), _vm._v(" as something to be chosen without the possibility of giving rational grounds."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[56]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Kierkegaard was responding primarily to Immanuel Kant’s (1724-1804) effort to ground morality in reason. Kant denied that morality could be justified with reference to human desires, sentiments or feelings, or with reference to divine commands. He rejected utility and the tendency to produce individual happiness as moral criteria. The moral life can be secured only by reason; for the moral character of rules can be maintained only if they are universally recognizable and binding on everyone under all conditions. As Kant sees it, the task of moral philosophy is to discriminate between moral rules or maxims that are universal in scope and those that cannot be universalized. Kant proposed the following test of a maxim’s universal scope: “Never act except in such a way that"), _c('a', {
    attrs: {
      "id": "eNote0059"
    }
  }), _vm._v(" one could also will that the maxim should become a universal law.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[57]")])]), _vm._v(" Kant argues that the basic rules of traditional morality, such as “always tell the truth,” “always keep your promises” and “don’t commit suicide,” pass the rational test. However, according to MacIntyre, Kant uses “notoriously bad arguments” to sustain his case. For example, in the case of suicide, Kant argues that such an action contradicts the innate impulse to preserve our lives. His appeal to “innate impulse” seems to reintroduce desires or feelings into the project of justifying morality after Kant had earlier rejected such justifications. Additionally, Kant’s test allows many obviously immoral or nonmoral maxims to slip through. Such maxims as “Keep all your promises throughout your life except one,” “Persecute all those who hold false religious beliefs” and “Always eat mussels on Mondays in March” pass the test handily. Hence, as Kierkegaard saw clearly, Kant’s project failed.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Kant was responding to Denis Diderot, David Hume (1711-1776) and others who attempted to justify the moral life with reference to innate passions, desires or sentiments. In Diderot’s dialogue "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Rameau’s Nephew")]), _c('a', {
    attrs: {
      "id": "eNote0060"
    }
  }), _vm._v(","), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[58]")])]), _vm._v(" the narrator (“Me”) defends traditional morality against Rameau’s objections. The narrator argues that the rules of conservative morality lead to the most fulfilling realization of the passions and desires of human nature over the long haul. Rameau, whom the narrator describes as “one of the most bizarre people in this country,” objects that (1) immediate gratification of desire sometimes warrants breaking the moral code, (2) that even a long-term view justifies obeying the rules only insofar as they serve our desires and (3) that the world does not really work the way the moralist envisions. According to MacIntyre, Rameau’s objections cannot be answered within Diderot’s framework:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("For what divides them is the question of precisely which of our desires are to be acknowledged as legitimate guides to action, and which on the other hand are to be inhibited, frustrated or re-educated; and clearly this question cannot be answered"), _c('a', {
    attrs: {
      "id": "eNote0061"
    }
  }), _vm._v(" by trying to use our desires themselves as some sort of criterion."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[59]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("David Hume assumes that morality must be explained and justified either by reason or by the passions. Since he does not think reason can do the work, Hume develops a moral theory based on innate desires and passions. Hume explains:")]), _vm._v(" "), _c('p', {
    staticClass: "block"
  }, [_vm._v("Since morals, therefore, have an influence on the actions and affections, it follows, that they cannot be deriv’d from reason; and that because reason alone, as we have already prov’d, can never have any such influence. Morals excite passions, and produce or prevent actions. Reason of itself is utterly impotent in this particular."), _c('a', {
    attrs: {
      "id": "eNote0062"
    }
  }), _vm._v(" The rules of morality, therefore, are not conclusions of our reason."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[60]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In his "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Treatise of Human Nature")]), _vm._v(" (1739-1740), Hume faces the same challenge Diderot confronted: if we are clear that abiding by a moral rule does not serve our long-term interest, why not abandon it? According to Mac­Intyre, this question is no more answerable by Hume’s theory than within Diderot’s framework. In his later work "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Enquiry Concerning the Principles of Morals")]), _vm._v(" (1751), Hume invokes natural “sympathy” or altruism to bridge the gap between the “general and unconditional rules”"), _c('a', {
    attrs: {
      "id": "eNote0063"
    }
  }), _vm._v(" that morality demands and “our particular fluctuating, circumstance-governed desires, emotions, and interests.”"), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0063",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[61]")])]), _vm._v(" But why should “sympathy” be given such a privileged position among human motives? In MacIntyre’s opinion, it"), _c('a', {
    attrs: {
      "id": "eNote0064"
    }
  }), _vm._v(" is simply a “philosophical fiction” invented to keep Hume’s system from collapsing."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[62]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("According to MacIntyre, the Enlightenment project of justifying morality without reference to human nature and its end had to fail. Diderot, Kant and Kierkegaard all agree in rejecting the ancient teleological understanding of human nature, which assumed that human beings possess"), _c('a', {
    attrs: {
      "id": "eNote0065"
    }
  }), _vm._v(" an essence that can be actualized only by achieving its appropriate end."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[63]")])]), _vm._v(" To reject this teleological understanding is to drive a wedge between descriptions of fact and assertions of moral obligation. Within the teleological framework no such separation exists. To say that so-and-so is a good person is a description of fact; it is a description of the relationship between this person’s actions, affections and virtues and their essence and end. But within the Enlightenment framework no description of innate desires or reason, however subtle, can found and justify universal and binding moral obligations. And this failure has led modern culture into a night of moral confusion and strife where all parties assert rights arbitrarily, indignantly protest and engage in endless unmasking of their opponents.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "heading_id_5"
    }
  }, [_vm._v("Speaking of Christianity in a Post-Christian Culture")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In light of Taylor’s analysis of the self-understanding of contemporary Western society, we can see the difficulties facing anyone wanting to communicate the Christian view of God, human freedom or dignity to the modern self. While our contemporaries look within themselves for moral sources and authority to guide them toward fullness, Christianity points to the transcendent God, who is Lord and Judge. Hence, God may appear to them as a threat to their dignity, which they identify with autonomy. Even though Christianity affirms the ordinary life of work, marriage and children, it calls us to higher levels of holiness, devotion, love and faithfulness within this sphere. Whereas our contemporaries trust the innocence of their inner depths and seek expression in ways that transgress the bounds of traditional morality, Christianity denies the unambiguous goodness of nature’s first impulses. It warns against unruly passions, urges a self-discipline guided by divine law and urges us to love God above all other things. Christianity locates genuine human identity at a point in the space determined by the three axes of respect, fullness and dignity very different from that of contemporary society; indeed, it is so different that, from the perspective of the modern self, it can"), _c('a', {
    attrs: {
      "id": "eNote0066"
    }
  }), _vm._v(" appear as disrespect, unhappiness and debasement instead of respect, fullness and dignity."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[64]")])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Alasdair MacIntyre’s analysis, no less than Charles Taylor’s, shows how difficult it will be to explain the Christian understanding of God’s relationship to human freedom and dignity to our contemporaries. The current moral culture was founded on rejection of the traditional claim that human beings are given their essence and end by God. Even if it now also rejects all other foundations for morality—in reason or innate desires—it is not therefore more open to returning to tradition. Many of our contemporaries exhibit a viscerally negative reaction to assertions of authority, pretense of objectivity or arguments to truth in the moral sphere. They instinctively suspect all such claims as masking desire for power, and making those claims sets in motion the process of unmasking. To many people Christian calls for obedience to the divine law, for repentance and moral transformation sound like recipes for oppression. Promises of ultimate happiness and eternal life can be interpreted as attempts to rob people of the fullness possible in this life. And such worn Christian slogans as “true freedom is found in slavery to God” or “we find our real dignity on our knees” will sound as false as they do ridiculous.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Both Taylor and MacIntyre teach lessons we would be wise to take seriously if we care about explaining Christianity to our wary and wounded contemporaries. If Taylor is correct we must take seriously the three “strongly valued goods” of contemporary culture: respect, fullness and dignity. No one who appears to reject them can gain a hearing. Christians can affirm these values but not in the way the modern self understands them. Our first challenge, then, will be to show how the modern self’s aspirations fall short of our highest hopes for respect, fullness and dignity. Next, we need to explain how the Christian view of these values fulfills them in a way that secular thought does not. MacIntyre’s work teaches us to avoid the rhetoric of exclusive claims, protestations to objectivity and infallible proofs. Our contemporaries interpret these strategies as masking the “will to power” and dismiss them for that reason alone. Approaching people with the least hint of judgment or arrogance or love of argument will fail to produce the desired engagement. In my experience, patient listening, sincere probing and autobiographical confession is the only way to engage with our contemporaries in meaningful conversations about important matters.")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "heading_id_6"
    }
  }, [_vm._v("Looking Ahead")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The next three chapters explore three distinct attitudes toward God, each of which arises out of contemporary moral space. Understanding their humanity in terms of the values of respect, fullness and dignity, as these are understood by the dominant culture, determines the way modern people view God. The majority of our contemporaries reflexively defend the modern understanding of these values as self-evident and nonnegotiable. Since they hold these ideals as"), _c('a', {
    attrs: {
      "id": "eNote0067"
    }
  }), _vm._v(" foundational they tend to view God as threatening or irrelevant to them."), _c('span', {
    staticClass: "eNote"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes#eNote0067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[65]")])]), _vm._v(" Those who suspect that modern values are threatened by the idea of God will adopt an attitude of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("defiance")]), _vm._v(" or "), _c('em', {
    staticClass: "i"
  }, [_vm._v("subservience")]), _vm._v(" toward God. Others attempt to live in "), _c('em', {
    staticClass: "i"
  }, [_vm._v("indifference")]), _vm._v(" or forgetfulness of God. Each of these three attitudinal stances projects a certain image of God, which proves to be at variance with the image of God portrayed in the Christian faith.")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8d52e26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chap1.vue
// module id = 72
// module chunks = 0